module.exports = __webpack_public_path__ + "img/CovidSector_Infographics_4.92cffa81.png";